import { formatDate } from '../../../utils/dateTimeFns';

const formatAddress = (patient) => {
  if (!patient) return '--';

  const {
    shippingStreet,
    shippingCity,
    shippingState,
    shippingPostalCode,
    shippingCountry,
  } = patient;

  const addressParts = [
    shippingStreet?.trim(),
    shippingCity?.trim(),
    shippingState?.trim(),
    shippingPostalCode?.trim(),
    shippingCountry?.trim(),
  ].filter(Boolean);

  return addressParts.length > 0 ? addressParts.join(', ') : '--';
};

export const patientData = (searchApiResult) => {
  const resultArray = searchApiResult?.patients?.map((patient) => ({
    name: {
      id: patient.id,
      item: [patient?.firstName || '', patient?.lastName || '']
        .join(' ')
        .trim(),
    },
    cochlearId: patient?.id ?? '--',
    dob: formatDate(patient?.dateOfBirth),
    email: patient?.email ?? '--',
    phoneNumber: patient?.mobile ?? '--',
    address: formatAddress(patient),
  }));

  return resultArray;
};
